<template>
  <div v-if="isDataFetched">
    <div style="display: flex; justify-content: end; margin-right: 1%; margin-bottom: 2%">
      <avs-chip
        :label="false"
        outlined
        color="secondary"
        styleC="width: 400px"
      >
        {{ $t("messages.information.chosen_project") }}: {{ mainFilters.project[0].name }}
      </avs-chip>
    </div>
    <PolarNC :inspections="polar" />
    <avs-card class="mt-4">
      <template v-slot:title>
        <v-card-title>{{ $t("categories.nonconformity.action.details") }}</v-card-title></template
      ><template v-slot:content>
        <v-row>
          <v-col
            cols="2"
            class="mt-16 ml-4 mr-10"
          >
            <v-select
              v-model="inspection"
              outlined
              dense
              :items="inspectionsActions"
              label="Inspection"
            ></v-select>
            <v-select
              v-model="nonConformity"
              dense
              :items="nonConformities"
              :item-text="item => `${item.id} - ${item.name}`"
              item-value="id"
              label="Nonconformities"
              outlined
              return-object
            ></v-select>
          </v-col>
          <v-col
            cols="8"
            class="ml-10"
          >
            <BarStackedActions
              :actions="actions"
              :inspection="inspection"
              :nonConformityId="nonConformity.id"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="2"
            class="mt-16 ml-4 mr-10"
          >
            <v-select
              v-model="user"
              outlined
              dense
              :items="userItems"
              label="User"
            ></v-select>
          </v-col>
          <v-col
            cols="8"
            class="ml-10"
          >
            <UsersActions
              :informationsUsers="informationsUsers"
              :user="user"
            />
          </v-col>
        </v-row>
      </template>
    </avs-card>
  </div>
</template>

<script>
import { BarStackedActions, PolarNC, UsersActions } from "@/components"
import ReportService from "@/services/ReportService"

export default {
  components: {
    BarStackedActions,
    PolarNC,
    UsersActions
  },
  name: "DashboardNonConformity",
  props: {
    companyId: { type: Number, required: true },
    mainFilters: {
      type: Object
    }
  },
  data() {
    return {
      actions: [],
      informationsUsers: [],
      inspection: null,
      inspectionsActions: [],
      inspectionsUsers: [],
      isDataFetched: false,
      itemsAreas: [],
      nonConformities: [],
      nonConformity: null,
      others: {},
      polar: [],
      user: null,
      userItems: []
    }
  },
  mounted() {
    this.getDatasDashboardNonConformities()
  },
  methods: {
    getDatasDashboardNonConformities() {
      ReportService.getDatasDashboardNonConformities(this, this.companyId, this.mainFilters)
        .then(r => {
          this.actions = r.action
          this.polar = r.polar
          this.inspectionsUsers = r.user

          this.inspectionsActions = this.actions.map(e => e.name)
          this.inspection = this.inspectionsActions[0]
          this.mainFilters.polarEvent = this.itemsAreas[0]
          this.nonConformityItems()
        })
        .finally(() => (this.isDataFetched = true))
    },
    nonConformityItems() {
      this.nonConformities = []
      this.actions.forEach(element => {
        if (element.name == this.inspection) {
          this.nonConformities = element.non_conformity.map(e => ({ id: e.id, name: e.name }))
        }
      })
      this.nonConformity = this.nonConformities[0]
      this.usersItems()
    },
    usersItems() {
      this.userItems = []
      this.inspectionsUsers.forEach(element => {
        if (element.name == this.inspection) {
          element.non_conformity.forEach(nc => {
            if (nc.id == this.nonConformity.id) {
              this.informationsUsers = nc.users
              this.userItems = nc.users.map(u => u.user)
            }
          })
        }
      })
      this.user = this.userItems[0]
    }
  },
  watch: {
    "mainFilters.project": {
      handler(newValue, oldValue) {
        this.inspectionsActions = []
        this.inspections = []
        this.getDatasDashboardNonConformities()
      },
      deep: true
    },
    "mainFilters.polarInspection": {
      handler(newValue, oldValue) {
        this.getDatasDashboardNonConformities()
      },
      deep: true
    },
    inspection: {
      handler(newValue) {
        this.nonConformityItems()
      }
    },
    inspectionsActions: {
      handler(newValue, oldValue) {
        this.inspection = this.inspectionsActions[0]
        this.nonConformityItems()
      },
      deep: true
    }
  }
}
</script>
